@if (isLoading()) {
  <div class="spinner-container">
    <mat-spinner></mat-spinner>
    <p class="spinner-message">This may take a moment, please wait...</p>
  </div>
} @else {
  @if (showRatingForm() && !feedbackSent()) {
    <app-feedback-view (submitFeedback)="onSubmitFeedback($event)">
    </app-feedback-view>
  } @else if (feedbackSent()) {
    <app-confirmed-feedback />
  } @else {
    <app-error-component [errorMessage]="errorMessage()"></app-error-component>
  }
}
